export const navLinks = [
  { label: '首页', href: '/' },
  { label: '禅意故事', href: '/category/chan-yi-gu-shi' },
  { label: '修行哲学', href: '/category/xiu-xing-zhe-xue' },
  { label: '生活美学', href: '/category/sheng-huo-mei-xue' },
  { label: '艺术形象', href: '/category/yi-shu-xing-xiang' },
  { label: '现代传承', href: '/category/xian-dai-chuan-cheng' },
  { label: '关于我们', href: '/about' },
];